<template>
  <el-menu
    class="el-menu-demo"
    mode="horizontal"
    :default-active="activeIndex"
  >
    <el-menu-item v-permission="['home']" index="1">
      <a :href="home">追溯系统</a>
    </el-menu-item>
    <el-menu-item v-permission="['base&org']" index="2">
      <a>企业信息</a>
    </el-menu-item>
    <el-menu-item v-permission="['market']" index="3">
      <a :href="market">营销系统</a>
    </el-menu-item>
    <el-menu-item v-permission="['mws']" index="4">
      <a :href="wms">wms系统</a>
    </el-menu-item>
  </el-menu>
</template>
<script>

export default {
  data() {
    return {
      activeIndex: '2',
      home: process.env.VUE_APP_BASE_API,
      org: process.env.VUE_APP_BASE_API_org,
      market: process.env.VUE_APP_BASE_API_market,
      wms: process.env.VUE_APP_BASE_API_wms
    }
  },
  watch: {},
  methods: {}
}
</script>

<style lang="scss" >
.el-menu--horizontal > .el-menu-item {
    float: left;
    height: 50px;
    line-height: 60px;
    margin: 0;
    border-bottom: 2px solid transparent;
    color: #909399;
}
.app-breadcrumb.el-breadcrumb {
  display: inline-block;
  font-size: 14px;
  line-height: 50px;
  margin-left: 8px;

  .no-redirect {
    color: #97a8be;
    cursor: text;
  }
}
</style>
